import { ServiceError, ValidationError } from '../../../shared/error/Errors';

export class HandleEventValidationError extends ValidationError {
  constructor(cause?: unknown) {
    super(
      { title: '요청한 값이 유효하지 않습니다.', message: '유효한 값으로 요청하시기 바랍니다.' },
      { cause },
    );
  }
}

export class HandleEventServiceError extends ServiceError {
  constructor(cause?: unknown) {
    super({ title: '`/handle-event` API error', message: 'Internal Server Error' }, { cause });
  }
}
